import { render } from "./LeavePersonal.vue?vue&type=template&id=0404628e&scoped=true"
import script from "./LeavePersonal.vue?vue&type=script&lang=js"
export * from "./LeavePersonal.vue?vue&type=script&lang=js"

import "./LeavePersonal.vue?vue&type=style&index=0&id=0404628e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0404628e"]])

export default __exports__